// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Card Component Styles */
.card {
  margin-bottom: 0;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: auto;
}

.card__function-overlay {
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 8px;
}

.card__function-overlay--default {
  opacity: 0;
}

/* Fade in on hover */
.card__function-overlay--default:hover {
  opacity: 1;
  transition: all 0.2s;
}

.card__function-overlay--editing {
  opacity: 1;
}

/* CARD TYPES */
.card--default {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  background: #f6f5f1;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  height: 380px;
}

.card--artist {
  margin-bottom: 0.5rem;
}

.card--default:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e0;
}

.card.selected {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.card__image-container {
  width: 100%;
  height: 160px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.card__image-container--artist {
  height: 100%;
}

.card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s;
  display: block;
}

.card:hover .card__image {
  transform: scale(1.02);
}

/* CAPTION */
.card__image-caption {
  text-align: center;
  font-style: italic;
  width: 100%;
  margin-top: 0.5rem;
  display: inline-block;
  opacity: 0;
}

.card__image-caption--hover {
  opacity: 1;
}

.image-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
  font-size: 14px;
  z-index: 2;
}

.card__image-container:hover .image-nav {
  opacity: 1;
}

.image-nav.prev {
  left: 8px;
}

.image-nav.next {
  right: 8px;
}

.image-nav:hover {
  background: rgba(0, 0, 0, 0.8);
}

.image-dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
  z-index: 2;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  transition: background-color 0.2s;
}

.dot.active {
  background: white;
}

.card-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 220px;
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 6px 0;
  color: #2d3748;
  line-height: 1.3;
  height: 21px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.card-type-pill {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: calc(100% - 27px);
}

.card-details > * {
  margin: 0;
}

.card-link {
  color: #4299e1;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  margin-top: auto;
  display: inline-block;
  flex-shrink: 0;
}

.card-link:hover {
  text-decoration: underline;
}

.card-meta {
  font-size: 14px;
  color: #718096;
  line-height: 1.4;
}

.card-location {
  font-size: 13px;
  color: #718096;
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-extra-item {
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
  margin: 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-price {
  font-size: 16px;
  font-weight: 500;
  color: #2d3748;
}

.card-description {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.4;
  margin: 8px 0;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Skeleton Loading States */
.skeleton-shimmer {
  background: linear-gradient(90deg, #e2e8f0 0%, #edf2f7 50%, #e2e8f0 100%);
  background-size: 200% 100%;
  animation: loading-shimmer 1.5s ease-in-out infinite;
}

@keyframes loading-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-image {
  width: 100%;
  height: 100%;
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}

.skeleton-title {
  height: 21px;
  width: 60%;
  border-radius: 4px;
}

.skeleton-pill {
  height: 24px;
  width: 60px;
  border-radius: 12px;
  flex-shrink: 0;
}

.skeleton-line {
  height: 14px;
  border-radius: 4px;
  margin: 6px 0;
}

.skeleton-line-short {
  width: 40%;
}

.skeleton-line-medium {
  width: 70%;
}

.skeleton-line-long {
  width: 90%;
}

.skeleton-link {
  height: 14px;
  width: 100px;
  border-radius: 4px;
  margin-top: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-layout/Card/Card.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* Card Component Styles */\n.card {\n  margin-bottom: 0;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  width: auto;\n}\n\n.card__function-overlay {\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  padding: 8px;\n}\n\n.card__function-overlay--default {\n  opacity: 0;\n}\n\n/* Fade in on hover */\n.card__function-overlay--default:hover {\n  opacity: 1;\n  transition: all 0.2s;\n}\n\n.card__function-overlay--editing {\n  opacity: 1;\n}\n\n/* CARD TYPES */\n.card--default {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  background: #f6f5f1;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  height: 380px;\n}\n\n.card--artist {\n  margin-bottom: 0.5rem;\n}\n\n.card--default:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #cbd5e0;\n}\n\n.card.selected {\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.card__image-container {\n  width: 100%;\n  height: 160px;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.card__image-container--artist {\n  height: 100%;\n}\n\n.card__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s;\n  display: block;\n}\n\n.card:hover .card__image {\n  transform: scale(1.02);\n}\n\n/* CAPTION */\n.card__image-caption {\n  text-align: center;\n  font-style: italic;\n  width: 100%;\n  margin-top: 0.5rem;\n  display: inline-block;\n  opacity: 0;\n}\n\n.card__image-caption--hover {\n  opacity: 1;\n}\n\n.image-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.2s;\n  font-size: 14px;\n  z-index: 2;\n}\n\n.card__image-container:hover .image-nav {\n  opacity: 1;\n}\n\n.image-nav.prev {\n  left: 8px;\n}\n\n.image-nav.next {\n  right: 8px;\n}\n\n.image-nav:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.image-dots {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 4px;\n  z-index: 2;\n}\n\n.dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.6);\n  transition: background-color 0.2s;\n}\n\n.dot.active {\n  background: white;\n}\n\n.card-content {\n  padding: 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 220px;\n  overflow: hidden;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  gap: 8px;\n}\n\n.card-title {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 6px 0;\n  color: #2d3748;\n  line-height: 1.3;\n  height: 21px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.card-type-pill {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 12px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.card-details {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  height: calc(100% - 27px);\n}\n\n.card-details > * {\n  margin: 0;\n}\n\n.card-link {\n  color: #4299e1;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: auto;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.card-link:hover {\n  text-decoration: underline;\n}\n\n.card-meta {\n  font-size: 14px;\n  color: #718096;\n  line-height: 1.4;\n}\n\n.card-location {\n  font-size: 13px;\n  color: #718096;\n  margin: 4px 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-extra-item {\n  font-size: 14px;\n  color: #2d3748;\n  font-weight: 500;\n  margin: 4px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-price {\n  font-size: 16px;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.card-description {\n  font-size: 14px;\n  color: #4a5568;\n  line-height: 1.4;\n  margin: 8px 0;\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Skeleton Loading States */\n.skeleton-shimmer {\n  background: linear-gradient(90deg, #e2e8f0 0%, #edf2f7 50%, #e2e8f0 100%);\n  background-size: 200% 100%;\n  animation: loading-shimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes loading-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-image {\n  width: 100%;\n  height: 100%;\n}\n\n.skeleton-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  gap: 8px;\n}\n\n.skeleton-title {\n  height: 21px;\n  width: 60%;\n  border-radius: 4px;\n}\n\n.skeleton-pill {\n  height: 24px;\n  width: 60px;\n  border-radius: 12px;\n  flex-shrink: 0;\n}\n\n.skeleton-line {\n  height: 14px;\n  border-radius: 4px;\n  margin: 6px 0;\n}\n\n.skeleton-line-short {\n  width: 40%;\n}\n\n.skeleton-line-medium {\n  width: 70%;\n}\n\n.skeleton-line-long {\n  width: 90%;\n}\n\n.skeleton-link {\n  height: 14px;\n  width: 100px;\n  border-radius: 4px;\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
